export enum Direction {
  Left = "Left",
  Right = "Right"
}
// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface AuthState {}

export const enum AuthAction {
  logIn = "LogIn"
}
